import { Text } from '@loomhq/lens';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

import UploadIcon from 'components/ui-components/upload-icon';

import './styles.less';

class SharePageDropzone extends Component {
  state = {
    dragging: false,
  };

  render() {
    const { multiple = false } = this.props;
    const { dragging } = this.state;

    return (
      <Dropzone
        className="share-page-dropzone"
        disableClick={true}
        multiple={multiple}
        disabled={false}
        activeStyle={{ zIndex: 1000, position: 'absolute' }}
        onDragEnter={() => this.setState({ dragging: true })}
        onDragLeave={() =>
          this.setState({
            dragging: false,
          })
        }
        onDrop={this.handleDrop}
      >
        <>
          {dragging && (
            <div className="share-page-drag-and-drop-overlay">
              <div className="drag-and-drop-overlay-content p:xlarge">
                <div className="flex pb:xlarge justify:center">
                  <UploadIcon color="var(--lns-color-white)" size={13} />
                </div>
                <Text
                  size="xxlarge"
                  color="white"
                  fontWeight="bold"
                  alignment="center"
                >
                  Drop here!
                </Text>
              </div>
            </div>
          )}
        </>
      </Dropzone>
    );
  }

  handleDrop = files => {
    this.setState({ dragging: false });
    this.props.onDrop(files);
  };
}

export default SharePageDropzone;
